import PropTypes from 'prop-types';
import React from 'react';
import DashboardRowIcon from 'src/components/Dashboard/components/DashboardRowIcon';
import { getCaseIconAndTooltip } from 'src/components/Cases/utils';

const CaseRowIcon = ({
  iconStyle,
  isCaseMgmtProvider,
  serviceCase,
}) => {
  const { icon, iconTooltip } = getCaseIconAndTooltip({
    iconStyle,
    isCaseMgmtProvider,
    serviceCase,
  });

  return (
    <DashboardRowIcon
      iconTooltip={iconTooltip}
      permissions={serviceCase.permissions}
    >
      {icon}
    </DashboardRowIcon>
  );
};

CaseRowIcon.propTypes = {
  iconStyle: PropTypes.object,
  isCaseMgmtProvider: PropTypes.bool.isRequired,
  serviceCase: PropTypes.shape({
    permissions: PropTypes.object.isRequired,
  }).isRequired,
};

CaseRowIcon.defaultProps = {
  iconStyle: {
    width: '14px',
  },
};

export default CaseRowIcon;
